import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchDict } from "@/api/MLXC/countryServe/partyManage";
import { fetchList as placeList } from "@/api/PMS/placeManage/placeManage";
import { fetchPlaceAreaList, placeCloseList, placeCloseDelete } from "@/api/PMS/closedRepairManage/closedRepairManage";
import waves from "@/directive/waves"; // 水波纹指令

import add from "./add";
export default {
  name: "ComplexTable",
  components: {
    add: add
  },
  directives: {
    waves: waves
  },
  watch: {
    showDialog: function showDialog(n, o) {
      if (n) {
        this.init();
      }
    }
  },
  data: function data() {
    return {
      placeOptions: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      Id: -1,
      multipleSelection: [],
      dialogFormVisible: false,
      statusOptions: [],
      companyList: []
    };
  },
  created: function created() {
    this.getType();
    this.getCompany();
    this.init();
    this.getPlace();
  },
  methods: {
    getPlace: function getPlace() {
      var _this = this;

      placeList({}).then(function (res) {
        _this.placeOptions = res.data.data;
      });
    },
    getType: function getType() {
      var _this2 = this;

      fetchDict({
        dicType: "week_date"
      }).then(function (res) {
        _this2.statusOptions = res.data.data;
      });
    },
    getCompany: function getCompany() {
      var _this3 = this;

      fetchPlaceAreaList({
        page: 1
      }).then(function (res) {
        _this3.companyList = res.data.data;
      });
    },
    init: function init() {
      this.listQuery = {
        page: 1,
        limit: 10,
        areaId: "",
        week: "",
        placeId: ""
      };
      this.total = null;
      this.getList();
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true;
      placeCloseList(this.listQuery).then(function (response) {
        _this4.list = response.data.data;
        _this4.total = response.data.total;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 创建
    handleCreate: function handleCreate() {
      this.Id = -1;
      this.title = "添加";
      this.dialogFormVisible = true;
    },
    // 编辑
    handleUpdate: function handleUpdate(Id) {
      this.Id = Id;
      this.title = "编辑";
      this.dialogFormVisible = true;
    },
    delete: function _delete(Ids) {
      var _this5 = this;

      if (Ids.length > 0) {
        this.$confirm("你确定是要删除这些记录, 是否继续?", "提示").then(function () {
          placeCloseDelete(Ids).then(function (response) {
            _this5.getList();

            _this5.Alert({
              alertType: "delete"
            });
          });
        });
      } else {
        this.Alert({
          alertType: "nodata"
        });
      }
    },
    handleDelete: function handleDelete(Id) {
      var Ids = [];
      Ids.push(Id);
      this.delete(Ids);
    },
    handleDeletes: function handleDeletes() {
      var Ids = [];
      this.multipleSelection.forEach(function (row) {
        Ids.push(row.id);
      });
      this.delete(Ids);
    }
  }
};